export default function NotFound() {
  return (
    <div className="p-6 text-xl text-red-500">
      404 – Page Not Found
    </div>
  );
}
